(function (root) {
  'use strict';

  function pick(variants, options, totalVariants, currentVariantId) {
    if (!Array.isArray(variants) || variants.length !== Number(totalVariants)) return null;
    if (!Array.isArray(options)) return null;

    var colorIndex = options.findIndex(function (name) { return /^(shoe )?colou?r( name)?$/i.test(name); });
    var sizeIndex = options.findIndex(function (name) { return /^(shoe )?size$/i.test(name); });
    var widthIndex = options.findIndex(function (name) { return /^(shoe )?width$/i.test(name); });
    if (colorIndex < 0 || sizeIndex < 0) return null;

    var available = variants.filter(function (variant) { return variant.available === true; });
    if (!available.length) return null;

    function option(variant, index) { return variant['option' + (index + 1)]; }
    var sizes = [];
    var colorsBySize = {};
    var sizesByColor = {};
    var variantsByColor = {};
    available.forEach(function (variant) {
      var size = option(variant, sizeIndex);
      var color = option(variant, colorIndex);
      if (!size || !color) return;
      if (sizes.indexOf(size) === -1) sizes.push(size);
      if (!colorsBySize[size]) colorsBySize[size] = {};
      colorsBySize[size][color] = true;
      if (!sizesByColor[color]) sizesByColor[color] = {};
      sizesByColor[color][size] = true;
      if (!variantsByColor[color]) variantsByColor[color] = [];
      variantsByColor[color].push(variant);
    });
    if (!sizes.length) return null;

    // Numeric sizes sort numerically; otherwise retain the merchant's variant order.
    if (sizes.every(function (size) { return /^\d+(?:\.\d+)?$/.test(size); })) {
      sizes.sort(function (a, b) { return Number(a) - Number(b); });
    }
    var maxCoverage = Math.max.apply(null, sizes.map(function (size) {
      return Object.keys(colorsBySize[size]).length;
    }));
    var current = available.find(function (variant) {
      return String(variant.id) === String(currentVariantId);
    });
    if (current && colorsBySize[option(current, sizeIndex)] &&
        Object.keys(colorsBySize[option(current, sizeIndex)]).length === maxCoverage) return current;
    var minimumCoverage = Math.max(1, Math.floor(maxCoverage * 0.7));
    var eligibleSizes = sizes.filter(function (size) {
      return Object.keys(colorsBySize[size]).length >= minimumCoverage;
    });
    var midpoint = (sizes.length - 1) / 2;
    eligibleSizes.sort(function (a, b) {
      var distance = Math.abs(sizes.indexOf(a) - midpoint) - Math.abs(sizes.indexOf(b) - midpoint);
      if (distance) return distance;
      return Object.keys(colorsBySize[b]).length - Object.keys(colorsBySize[a]).length;
    });
    var chosenSize = eligibleSizes[0];

    var eligibleColors = Object.keys(colorsBySize[chosenSize]);
    eligibleColors.sort(function (a, b) {
      return Object.keys(sizesByColor[b]).length - Object.keys(sizesByColor[a]).length;
    });
    var chosenColor = eligibleColors[0];
    var candidates = variantsByColor[chosenColor].filter(function (variant) {
      return option(variant, sizeIndex) === chosenSize;
    });
    candidates.sort(function (a, b) {
      if (widthIndex >= 0) {
        var aMedium = /^(medium|m)$/i.test(option(a, widthIndex)) ? 1 : 0;
        var bMedium = /^(medium|m)$/i.test(option(b, widthIndex)) ? 1 : 0;
        if (aMedium !== bMedium) return bMedium - aMedium;
      }
      return (Number(b.inventory_quantity) || 0) - (Number(a.inventory_quantity) || 0);
    });
    return candidates[0] || null;
  }

  function shouldRedirect(url) {
    return !url.searchParams.has('variant') &&
      !url.searchParams.has('option_values') &&
      !url.searchParams.has('section_id');
  }

  root.OrthoticShopDefaultVariant = { pick: pick, shouldRedirect: shouldRedirect };
})(typeof window === 'undefined' ? globalThis : window);
